import { useQuery } from "@tanstack/react-query";
import { searchesQueryOptions } from "./useSearches";

export function useLightSearch(searchUuid: Uuid, orgUuid: Uuid) {
  const { data } = useQuery({
    ...searchesQueryOptions(orgUuid),
    select: (res) =>
      res.ok ? res.data.find((s) => s.uuid === searchUuid) : undefined,
    refetchInterval: (query) => {
      const res = query.state.data;
      const search = res?.ok
        ? res.data.find((s) => s.uuid === searchUuid)
        : undefined;
      return search?.is_initializing ? 10_000 : false;
    },
  });
  return data;
}
